<div *ngIf="page">
  <customer-site-fixed-bg
  *ngIf="page['name'] === 'home' && site.siteIntro['backgroundImage']"
  [style.background-image]="(site.siteIntro['backgroundImage'])? 'url(' + site.siteIntro['backgroundImage']['url'] + ')':'' | safe: 'style'">
</customer-site-fixed-bg>

  <customer-site-intro *ngIf="page['name'] === 'home'" [site]="site">
      <div class="customer-site-intro-copy" [innerHTML]="site['siteIntro']['html'] | safe: 'html'"></div>
  </customer-site-intro>
  <div>
    <div class="container-fluid section-container" 
      *ngFor="let section of page['sections'];" 
      [ngClass]="'section-' + section.type">

        <div *ngIf="section.type == SECTION_TYPE_CONTENT && calculateColumns(section) > 0" >
          <customer-site-section
              [class.site-section--background]="section['backgroundImage'] ? true : false"
              [ngStyle]="getSectionBackgroundStyle(section)"
              [class.full-width]="section['fullWidth'] ? true : false"
              [section]="section"
              [theme]="site['theme']"
              [columnCount]="calculateColumns(section)">
          </customer-site-section>
        </div>
        <jobs-search *ngIf="isBrowser && section.type == SECTION_TYPE_JOB_SEARCH" [themeColor]="site['theme']['buttonColor']"></jobs-search>

    </div>
  </div>

</div>


<customer-site-page-not-found *ngIf="!page"
    [themeColor]="site['theme']['buttonColor']"
    [site]="site"
></customer-site-page-not-found>
